module.exports = __webpack_public_path__ + "img/calendar-logo.e4a9b0bc.svg";